// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-nav-tabs/themes/vue-tabs.css
// module id = 1121
// module chunks = 2